import { Injectable } from '@angular/core';
import { BaseWebsocketService } from './base-websocket.service';
import { StatusUpdate } from '../models/message';

@Injectable({ providedIn: 'root' })
export class StatusWebsocketService extends BaseWebsocketService<StatusUpdate> {
  protected readonly wsEndpoint = 'status';
  protected readonly serviceName = 'StatusWebsocketService';

  statuses$ = this.messagesSubject.asObservable();

  constructor() {
    super([]);
  }

  protected handleMessage(event: MessageEvent): void {
    const message = JSON.parse(event.data) as StatusUpdate;
    this.zone.run(() => {
      const current = this.messagesSubject.getValue();
      this.messagesSubject.next([...current, message]);
    });
  }
}
